import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, useForm } from "react-hook-form";
import _ from "lodash";
import AuraBaseDialog from "app/main/apps/common/AuraBaseDialog";
import { cleanData, emptySchema } from "app/main/apps/common/AuraFunctions";
import { closeVasDialog } from "../../store/orderSlice";
import VasPreview from "../Vas/VasPreview";

export default function VasPreviewDialog(props) {
  const dispatch = useDispatch();
  const vasDialog = useSelector(
    ({ eCommerceApp }) => eCommerceApp?.order?.vasPreviewDialog
  );
  // const currentUser = useSelector(({ user }) => user);
  // const isManage = currentUser && FuseUtils.hasPermission(authPermissions.manage, currentUser.role);
  const isManage = true;

  const [dialogParam, setDialogParam] = useState({
    type: "View",
    name: "viewVas",
    title: "View Vas",
    hideDialogActions: true,
    maxWidth: "md",
  });
  const [dialogButtons, setDialogButtons] = useState(null);

  const methods = useForm({
    mode: "onChange",
  });
  const {
    setValue,
    watch,
    control,
    formState,
    getValues,
    reset,
    handleSubmit,
  } = methods;

  /**
   * Initialize Dialog with Data
   */
  const initDialog = useCallback(() => {
    const { param } = vasDialog;

    if (param) {
      if (param.dialogParam) setDialogParam(param.dialogParam);
      if (param?.dialogParam?.hideDialogActions === true) {
        setDialogButtons(
          param.dialogParam.name === "savePreview"
            ? { showBack: true, showSave: true }
            : { showClose: true }
        );
      }
    }
    if (vasDialog.data) {
      reset({ ...vasDialog.data });
    }
  }, [vasDialog, reset, isManage]);

  /**
   * On Dialog Open
   */
  useEffect(() => {
    if (vasDialog.props.open) {
      initDialog();
    }
  }, [vasDialog.props.open, initDialog]);

  /**
   * Close Dialog
   */
  function closeDialog() {
    dispatch(
      closeVasDialog({
        field: "vasPreviewDialog",
      })
    );
  }

  /**
   * Save click
   */
  function onSubmit() {
    vasDialog.param.onSave();
    closeDialog();
  }

  return vasDialog && vasDialog.props && vasDialog.props.open ? (
    <FormProvider {...methods}>
      <AuraBaseDialog
        dialogProps={vasDialog.props}
        closeDialog={closeDialog}
        onSubmit={onSubmit}
        dialogParam={dialogParam}
      >
        <VasPreview
          data={vasDialog.data}
          completeOrderData={vasDialog.completeOrderData}
          onSave={onSubmit}
          onBack={closeDialog}
          onClose={closeDialog}
          dialogParam={dialogParam}
          dialogButtons={dialogButtons}
        />
      </AuraBaseDialog>
    </FormProvider>
  ) : (
    <></>
  );
}
